/* German display labels only; upload fields, values and app handlers stay intact. */
(() => {
  if (!location.pathname.endsWith('/fotomagnete-personalisieren')) return;
  const scope = '#pplr-16164532945230, #pplr_html, .pplr_crop-modal';
  const translations = new Map([
    ['Upload', 'Foto hochladen'], ['or drop file here to upload', 'oder Foto hier ablegen'],
    ['Crop', 'Zuschneiden'], ['Remove', 'Entfernen'], ['Done', 'Übernehmen'],
    ['Cancel', 'Abbrechen']
  ]);
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script,style,textarea,option')) continue;
      const replacement = translations.get(node.nodeValue.trim());
      if (replacement) node.nodeValue = node.nodeValue.replace(node.nodeValue.trim(), replacement);
    }
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      document.querySelectorAll(scope).forEach(translate);
    });
  }
  new MutationObserver(records => {
    if (records.some(record => record.target.nodeType === Node.ELEMENT_NODE &&
      (record.target.closest?.(scope) || [...record.addedNodes].some(node =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches?.(scope) || node.querySelector?.(scope)))))) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('pplrAppInitiated', schedule);
  schedule();
})();
